export default __webpack_public_path__ + "39a020b4ae7445df378f597b6a96b5b9.svg";